import './App.css';
import Careers from './Pages/CareersHome';

function App() {
  return (
    <Careers/>
  );
}

export default App;
